<template>
  <div class="container">
    <div class="left_box" >

      <el-dialog title="待办任务" class="dialog" v-if="waitVisible" :visible="waitVisible" width="50%" @close="waitVisible = false">
        <FriendChat/>
        <span slot="footer" class="dialog-footer">
          <el-button @click="waitVisible = false">关 闭</el-button>
        </span>
      </el-dialog>

      <div class="top_box">
        <p class="tb">工单任务</p>
        <router-link to="/workorder/list">
          <div class="list_box" v-if="qx1">
            <div class="title">
              <p class="bt">待处理</p>
              <p class="num">{{ resolution }}</p>
            </div>
            <img src="@/icons/daichuli.png" alt="" srcset="" />
          </div>
        </router-link>
        <div class="list_box" @click="Jump('TaskClaim')">
          <div class="title">
            <p class="bt">待认领</p>
            <p class="num">{{ wait_pickup }}</p>
          </div>
          <img src="@/icons/dairenl.png" alt="" srcset="" />
        </div>
        <div class="list_box" @click="Jump('Taskexecute')">
          <div class="title">
            <p class="bt">执行中</p>
            <p class="num">{{ wait_do }}</p>
          </div>
          <img src="@/icons/zhixinz.png" alt="" srcset="" />
        </div>
        <div class="list_box" @click="Jump('TaskEnd')">
          <div class="title">
            <p class="bt">已完结</p>
            <p class="num">{{ finish }}</p>
          </div>
          <img src="@/icons/wanj.png" alt="" srcset=""/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTaskTotal } from "@/api/home";
import FriendChat from "@/views/chat/FriendChat.vue";
import { postWorkOrderList } from "@/api/work/WorkOrderList";
export default {
  data() {
    return {
      waitVisible: false,
      name: "HomePage",
      finish: 0,
      wait_do: 0,
      wait_pickup: 0,
      resolution: 0,
      userRoleId: null,
      qx1: false,
      queryParams: {
        condition: {
          orderStatus: "wait_received",
        },
        limit: 10,
        page: 1,
        orders: [
          {
            asc: true,
            column: "createTime",
          },
        ],
      },
    };
  },
  props:{
    msgTotal: Number
  },
  components: {
    FriendChat
  },
  created() {
    this.waitVisible = (this.$store.state.chatDialogVisible === '1' && (this.msgTotal > 0));
    this.$store.commit('switchChatDialogtip','0');
    sessionStorage.setItem('chatDialogVisible','0');
    this.getData();
    this.userRoleId = sessionStorage.getItem("userRoleId");
    this.quanxian();
  },
  mounted() {},
  methods: {
    //权限
    quanxian() {
      if (
        this.doesItContain([1, 6, 26, 32, 34, 35, 36, 38, 42, 43, 44]).length >
        0
      ) {
        // 部门主管接收工单
        this.qx1 = true;
      }
    },

    async getData() {
      let resp = await postWorkOrderList(this.queryParams);
      this.resolution = resp.data.total;
      let { data } = await getTaskTotal();
      data.map((item) => {
        if (item.taskStatus == "finish") {
          this.finish = item.total;
        }
        if (item.taskStatus == "wait_do") {
          this.wait_do = item.total;
        }
        if (item.taskStatus == "wait_pickup") {
          this.wait_pickup = item.total;
        }
      });
    },
    Jump(name) {
      this.$router.push({ path: "/task/list", query: { name: name } });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog{
  font-family: none;
}
.router-link-active {
  text-decoration: none;
  color: #409eff;
}
a {
  text-decoration: none;
  color: #409eff;
}
.container {
  width: 100%;
  display: flex;
  margin-bottom: 30px;
  padding: 0;
  .left_box {
    width: 15%;
    display: flex;
    .top_box {
      width: 80%;
      .tb {
        font-size: 18px;
        text-align: left;
        color: #666565;
        font-weight: 600;
      }
      .list_box {
        width: 150px;
        padding: 15px 20px;
        border-radius: 4px;
        box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #ffffff;
        margin-top: 16px;
        cursor: pointer;
        .title {
          .bt {
            font-size: 18px;
          }
        }
        img {
          width: 50px;
          height: 50px;
          margin-left: 20px;
        }
      }
    }
  }
}
</style>